import React, { useEffect, useRef, useState } from 'react';
import { PackageX, Clock, AlertTriangle } from 'lucide-react';
import { problemData } from '../data/mock';

const iconMap = {
  'PackageX': PackageX,
  'Clock': Clock,
  'AlertTriangle': AlertTriangle
};

const ProblemSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} className="py-24 bg-gray-50">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className={`text-center mb-16 transform transition-all duration-700 ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
          }`}>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              {problemData.title}
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              {problemData.description}
            </p>
          </div>

          {/* Problem Cards */}
          <div className="grid md:grid-cols-3 gap-8">
            {problemData.problems.map((problem, index) => {
              const Icon = iconMap[problem.icon];
              return (
                <div
                  key={index}
                  className={`bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100 transform ${
                    isVisible 
                      ? 'translate-y-0 opacity-100' 
                      : 'translate-y-10 opacity-0'
                  }`}
                  style={{ transitionDelay: `${index * 100 + 200}ms` }}
                >
                  <div className="w-16 h-16 bg-gradient-to-br from-red-50 to-red-100 rounded-xl flex items-center justify-center mb-6 shadow-md">
                    <Icon className="w-8 h-8 text-red-600" />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">
                    {problem.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {problem.description}
                  </p>
                </div>
              );
            })}
          </div>

          {/* Impact Statement */}
          <div className={`mt-16 bg-gradient-to-r from-red-600 to-red-700 rounded-2xl p-8 text-center shadow-2xl transform transition-all duration-700 delay-500 ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
          }`}>
            <p className="text-2xl md:text-3xl font-bold text-white">
              Don't let poor supply chains destroy your bottom line.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
